<template>
  <div>
    <div>
      <div class="title-container">
        <!-- 装饰元素 -->
        <dv-decoration-10 style="width:40%;height:5px;"/>
        <div class="title-wrapper ">
          <!-- 左侧装饰 -->
          <dv-decoration-8 class="decoration-side" style="width:150px;height:50px;" :color="decorationColor"/>
          <div class="title-box">
            <div id="text" class="title-text" style=""></div>
            <dv-decoration-6 style="width:150px;height:30px;margin: 0 auto;"/>
          </div>
          <dv-decoration-8 class="decoration-side" style="width:150px;height:50px;" :reverse="true"
                           :color="decorationColor"/>
        </div>
        <dv-decoration-10 style="width:40%;height:5px;transform: scale(-1, -1);"/>
      </div>    <!-- title -->
      <div style="display: flex;justify-content: space-between;">
        <div class="trapezoid-box">
          <div style="display: flex;justify-content: space-between;align-items: center;width: 50%;">
            <!-- 自定义下拉菜单 -->
            <div class="custom-dropdown"
                 @click.stop="toggleDropdown">
              菜单
              <i class="el-icon-menu"></i>
            </div>
            <div style="font-size: 14px" @click="exportPublic" v-if="location === 'tourismPublicOpiniocScreen' ">
              <i class="el-icon-link"></i>
              <span>导出</span>
            </div>
<!--            <el-select-->
<!--                @change="addressList()"-->
<!--                style="width:150px ;margin-left: 150px;"-->
<!--                v-model="value"-->
<!--                class="custom-select"-->
<!--                placeholder="区域选择">-->
<!--              <el-option-->
<!--                  v-for="item in options"-->
<!--                  :key="item.value"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value">-->
<!--              </el-option>-->
<!--            </el-select>-->
          </div>
        </div>
        <div class="trapezoid-box-right">
          <div style="width: 40%">
            <el-date-picker
                v-if=" location === 'passengerFlow' "
                v-model="value2"
                @change="getTimeOne()"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
            <el-date-picker
                v-else
                @change="getTime()"
                v-model="value1"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <h2 style="width: 40%;font-size: 14px">
            <span class="text backGround-line">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
          </h2>
        </div>
      </div>
      <!-- 下拉菜单容器（挂载到 body） -->
      <div
          id="target"
          ref="dropdownContainer"
          v-if="isDropdownOpen"
          class="dropdown-content "
          :style="dropdownStyle">
        <div class="dropdown-grid">
          <div
              v-for="(item, index) in menuItems"
              :key="index"
              class="dropdown-item"
              @click="handleMenuItemClick(item)"
              :class="{ active: selectedItem === item }">
            <div class="menu-icon">
              <!-- 可以在这里添加图标 -->
              <i v-if="item.value === 'index'" class="el-icon-s-home"></i>
              <i v-else-if="item.value === 'home'" class="el-icon-data-line"></i>
              <!-- 其他图标... -->
              <img style="width: 24px;height: 24px;color: #4ade80" v-else-if="item.value === 'propagationAnalysis'" src="@/image/Nav/chuanbofenxi.png" alt="">
              <img style="width: 24px;height: 24px;color: #4ade80" v-else-if="item.value === 'users'" src="@/image/Nav/yuqingjiance.png" alt="">
              <img style="width: 24px;height: 24px;color: #4ade80" v-else-if="item.value === 'touristSatisfaction'" src="@/image/Nav/youkemanyiduguanli.png" alt="">
              <img style="width: 24px;height: 24px;color: #4ade80" v-else-if="item.value === 'brandEvaluation'" src="@/image/Nav/jingdian.png" alt="">
              <img style="width: 24px;height: 24px;color: #4ade80" v-else-if="item.value === 'passengerFlowTrend'" src="@/image/Nav/keliuqushi.png" alt="">
              <img style="width: 24px;height: 24px;color: #4ade80" v-else-if="item.value === 'passengerFlow'" src="@/image/Nav/shishikeliu.png" alt="">
              <img style="width: 24px;height: 24px;color: #4ade80" v-else-if="item.value === 'travelRelatedConsumption'" src="@/image/Nav/shelv.png" alt="">
<!--              <img style="width: 24px;height: 24px;color: #4ade80" v-else-if="item.value === 'visitorSpending'" src="@/image/Nav/xiaofeihuaxiang.png" alt="">-->
              <img style="width: 24px;height: 24px;color: #4ade80" v-else-if="item.value === 'passengerFlowDistribution'" src="@/image/Nav/xiaofeihuaxiang.png" alt="">
              <i v-else-if="item.value === 'analytics' " class="el-icon-user"></i>
            </div>
            <div class="menu-label">{{ item.label }}</div>
            <span v-if="selectedItem === item" class="checkmark">✓</span>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import {formatTime} from "@/utils/index.js";
import streamText from "@/utils/streamingOutput";
import router from "@/router";
export default {
  props: {
    title: {
      type: String,
      required: true
    },
  },
  components: {},
  data() {
    return {
      location:'',
      decorationColor: ["#568aea", "#000000"],
      dataTime:{
        startTime:'',
        endTime:''
      },
      value: '',
      value1: "",
      value2:'',
      dateDay: "xx",
      dateYear: "xxxx",
      dateWeek: 'xx',
      options: [
        {value: '选项1', label: '安徽'},
        {value: '选项2', label: '北京'},
        {value: '选项3', label: '上海'},
        {value: '选项4', label: '广州'},
        {value: '选项5', label: '深圳'}
      ],
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      isDropdownOpen: false,
      dropdownStyle: {
        top: '0px',
        left: '0px'
      },
      dropdownEl: null,
      menuItems: [
        {label: '首页', value: 'index', path: '/'},
        {label: '互联网数据中心', value: 'home', path: '/dataCenterScreen'},
        {label: '舆情监测', value: 'users', path: '/tourismPublicOpiniocScreen'},
        {label: '游客行为画像', value: 'analytics', path: '/UserPortrait'},
        {label: '传播分析', value: 'propagationAnalysis', path: '/propagationAnalysis'},
        {label: '游客满意', value: 'touristSatisfaction', path: '/touristSatisfaction'},
        {label: '品牌评估', value: 'brandEvaluation', path: '/brandEvaluation'},
        {label: '客流趋势', value: 'passengerFlowTrend', path: '/passengerFlowTrend'},
        {label: '实时客流', value: 'passengerFlow', path: '/passengerFlow'},
        {label: '涉旅消费', value: 'travelRelatedConsumption', path: '/travelRelatedConsumption'},
        // {label: '游客消费画像', value: 'visitorSpending', path: '/visitorSpending'},
        {label: '客流分布', value: 'passengerFlowDistribution', path: '/passengerFlowDistribution'},
      ],
      selectedItem: null,
    };
  },
  methods: {
    router() {
      console.log(location.href);
      return router

    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isDropdownOpen) {
        this.positionDropdown();
      }
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    positionDropdown() {
      const triggerEl = this.$el.querySelector('.custom-dropdown');
      if (!triggerEl) return;

      const rect = triggerEl.getBoundingClientRect();
      this.dropdownStyle = {
        top: `${rect.bottom + window.scrollY}px`,
        left: `${rect.left + window.scrollX}px`
      };
    },
    handleClickOutside(event) {
      if (!this.dropdownEl || this.dropdownEl.contains(event.target) || this.$el.contains(event.target)) {
        return;
      }
      this.closeDropdown();
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    getTime() {
      if (!this.value1 || this.value1.length < 2) return;

      function formatDateToYMD(date) {
        const y = date.getFullYear().toString();
        const m = ('0' + (date.getMonth() + 1)).slice(-2);
        const d = ('0' + date.getDate()).slice(-2);
        return `${y}-${m}-${d}`;
      }

      const formattedDates = this.value1.map(date => formatDateToYMD(date));
      this.dataTime = {
        startTime: formattedDates[0],
        endTime: formattedDates[1],
      }
      console.log(formattedDates)
      this.$emit('getTime', formattedDates);
    },
    getTimeOne(){
      console.log(this.value2);
      this.$emit('getTime',this.value2);
    },
    addressList() {
      this.$emit('address', this.value);
    },
    handleMenuItemClick(item) {
      this.selectedItem = item;
      this.closeDropdown();
      this.$router.push({path: `${item.path}`});
    },
    setSelectedItemByRoute() {
      const currentPath = this.$route.path;
      this.selectedItem = this.menuItems.find(item => item.path === currentPath) || null;
    },
    handleOutsideClick() {
      this.isDropdownOpen = false
    },
    exportPublic(){
        const url = `https://daping.cloota.net/api/publicOption/exportPublicData?startTime=${this.dataTime.startTime}&endTime=${this.dataTime.endTime}`; // 替换为你的API地址
      console.log(url)
        const a = document.createElement('a');
        a.href = url;
        a.download = 'filename.xlsx'; // 设置下载文件名
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
  },
  mounted() {

    this.timeFn();
    document.addEventListener('click', this.handleClickOutside);

    // 将下拉菜单移入 body 避免被遮挡
    this.dropdownEl = this.$refs.dropdownContainer;
    if (this.dropdownEl && this.dropdownEl.parentNode) {
      document.body.appendChild(this.dropdownEl);
    }
    this.setSelectedItemByRoute();

    // 可选：监听路由变化
    this.routeUnwatch = this.$watch('$route', () => {
      this.setSelectedItemByRoute();
    });
    setTimeout(() => {
      document.body.style.visibility = 'visible'
    }, 1000)

    this.handleClickOutside = (event) => {
      const targetElement = document.getElementById('target');
      if (!targetElement || !targetElement.contains(event.target)) {
        this.handleOutsideClick();
      }
    };
    document.addEventListener('click', this.handleClickOutside);

    const text = document.getElementById('text');
    streamText(this.title,text,500)

   this.location = window.location.href.split('/').pop()
    console.log(this.location)
  },
  beforeDestroy() {
    clearInterval(this.timing);
    document.removeEventListener('click', this.handleClickOutside);

    // 移除 body 中的下拉菜单
    if (this.dropdownEl && this.dropdownEl.parentNode === document.body) {
      document.body.removeChild(this.dropdownEl);
    }
  }
};
</script>

<style scoped lang="scss">
.custom-dropdown {
  position: relative;
  display: inline-block;
  cursor: pointer;
  padding: 8px 12px;
  background-color: transparent;
  border: none;
  color: white;
  font-size: 14px;
}


.dropdown-content {
  position: absolute;
  width: 500px; /* 加宽以适应三列布局 */
  background: rgba(15, 23, 42, 0.95);
  border: 1px solid rgba(74, 222, 128, 0.3);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  padding: 15px;
  color: white;
  font-size: 14px;
  z-index: 9999;
  backdrop-filter: blur(10px);
  animation: fadeIn 0.2s ease-in-out;
}

.dropdown-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.dropdown-content:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
}

.dropdown-item {
  padding: 12px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  height: 80px;
  position: relative;
  border: 1px solid transparent;

  &:hover {
    background: rgba(74, 222, 128, 0.1);
    border-color: rgba(74, 222, 128, 0.3);
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(74, 222, 128, 0.2);
  }

  &.active {
    background: rgba(74, 222, 128, 0.15);
    border-color: rgba(74, 222, 128, 0.5);
  }
}

.dropdown-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
  transform: translateX(4px);
}

.dropdown-item.active {
  background-color: #3a3a3a;
  color: #00d1b2;
}

.checkmark {
  color: #00d1b2;
  font-weight: bold;
  font-size: 14px;
}

.trapezoid-box {
  width: 50%;
  height: 50px;
  //z-index: 1000;
  /* 确保足够高 */
  background: #0f1325;
  color: white;
  padding: 20px;
  box-sizing: border-box;
  clip-path: polygon(0% 0%,
    /* 左上 */
      80% 0%,
    /* 右上 */
      100% 100%,
    /* 右下 */
      0% 100% /* 左下 */
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  /* 包含内边距到尺寸计算中 */

}

.trapezoid-box-right {
  width: 50%;
  height: 50px;
  color: white;
  background: #0f1325;
  text-align: right;
  padding: 20px;
  /* box-sizing: border-box; */
  clip-path: polygon(20% 0%,
    /* 左上 */
      100% 0%,
    /* 右上 */
      100% 100%,
    /* 右下 */
      0% 100% /* 左下 */
  );
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: right;
  font-family: sans-serif;
  box-sizing: border-box;
  /* 包含内边距到尺寸计算中 */
}

/* 阴影动画 */
.dropdown-content::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  filter: blur(10px);
}

/* 淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-content::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 10px;
  background: linear-gradient(45deg, rgb(14 16 16 / 50%), rgba(37, 67, 50, 0.5), rgba(81, 31, 81, 0.5));
  z-index: -1;
  animation: borderGlow 3s linear infinite;
  background-size: 200% 200%;
}

::v-deep.el-date-editor .el-range-input {
  background-color: transparent !important;
}


:deep(.custom-select .el-input__inner) {
  background-color: transparent !important; /* 替换为你想要的颜色 */
  color: white; /* 可选：文字颜色 */
  border: none; /* 可选：去掉边框 */
}

:deep(.el-input__inner) {
  background-color: transparent !important;
  border: none !important;
  //padding: 0;
}


.title-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  margin-bottom: 5px; /* 预留标题与内容的间距 */
}

.title-wrapper {
  //   position: relative; /* 作为子元素绝对定位的基准 */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.decoration-side {
  margin: 0 10px; /* 装饰元素与标题的间距 */
}

.title-box {
  text-align: center;
  //position: relative; /* 确保内部装饰元素定位正确 */
}

.title-text {
  margin-bottom: 10px; /* 标题与下方装饰的间距 */
  background: linear-gradient(92deg, #0072ff 0%, #00eaff 48.85253906%, #01aaff 100%); /* 从左到右的渐变 */
  -webkit-background-clip: text; /* 将背景裁剪为文字形状 */
  background-clip: text;
  color: transparent; /* 让文字本身透明，显示背景渐变 */
  text-align: center;
  font-size: 24px;
  height: 30px;
  line-height: 30px;
  width: 300px;
}

.icon-menu {
  font-size: 24px; /* 图标大小 */
  z-index: 10; /* 确保图标在上方 */
}

.menu-icon {
  font-size: 24px;
  margin-bottom: 8px;
  //color: #4ade80;
}

.menu-label {
  text-align: center;
  font-size: 13px;
}

.checkmark {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #4ade80;
  font-weight: bold;
  font-size: 12px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .title-text {
    font-size: 24px;
    width: 240px;
  }
  .icon-menu {
    left: 5%;
    top: -15px;
  }
}
@keyframes borderGlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
